import React from "react";
import { Box, IconButton,ListItemButton } from "@mui/material";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const NextArrow = (props) => {
  const { onClick } = props;
  return (
    <IconButton
      onClick={onClick}
      sx={{
        position: "absolute",
        top: "5%",
        right: "0px",
        transform: "translateY(-50%)",
        zIndex: 1,
        color: "black",
        backgroundColor: "transparent",
        "&:hover": { backgroundColor: "grey.200" },
      }}
    >
      <ListItemButton>
        
      <i className="fa-solid fa-arrow-right"></i>
</ListItemButton>



    </IconButton>
  );
};

const PrevArrow = (props) => {
  const { onClick } = props;
  return (
    <IconButton
      onClick={onClick}
      sx={{
        position: "absolute",
        top: "5%",
        left: "0px",
        transform: "translateY(-50%)",
        zIndex: 1,
        color: "black",
        backgroundColor: "Transparent",
        "&:hover": { backgroundColor: "grey.200" },
      }}
    >
      
      <ListItemButton>
      <i className="fa-solid fa-arrow-left"></i>
  {/* <span style={{ fontSize: '30px' }}>⬅</span> this is your arrow */}
</ListItemButton>

    </IconButton>
  );
};


const PortfolioCarousel = ({ PortfolioDetails }) => {
  const settings = {
    dots: true,
    infinite: true,
    arrows: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    cssEase: "ease-in-out",
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    lazyLoad: "ondemand",
  };

  return (
    <div
      className="slider-container"
      style={{
        width: "100%",
        maxWidth: "900px",
        margin: "0 auto",
        overflow: "hidden",
        paddingBottom: "80px",
        position: "relative",
        minHeight: "500px", // <---- Add this line
        height: "600px",   // <---- Add fixed height
      }}
    >
      <Slider {...settings}>
        {PortfolioDetails?.additionalImages?.map((image, index) => (
          <Box
            key={index}
            component="img"
            src={image}
            alt={`Slide ${index + 1}`}
            sx={{
              width: "100%",
              height: "100%",
              maxHeight: "500px",
              objectFit: "contain",
              transition: "opacity 0.5s ease-in-out", // <--- Add this
              borderRadius: 2,
              display: "block",
            }}
          />
        ))}
      </Slider>
    </div>
  );
};

export default PortfolioCarousel;
